var ShuttleContainerCandidates;

import OrganizationShuttleSelectPopover from 'trunks/vue/admin/compositions/organizations/responses/add_members_modals/organization_shuttle_select_popover.js';

export default ShuttleContainerCandidates = {
  components: {
    'organization-shuttle-select-popover': OrganizationShuttleSelectPopover
  },
  template: `<div class="shuttle-box left">
  <div class="justify-box mb-2">
    <div class="content light-gray-text">备选成员</div>
    <organization-shuttle-select-popover @updateSelectedOrganizationId='updateSelectedOrganizationIdFunc' />
  </div>

  <div class="input-control left-addon mb-4">
    <input
      class="controlled-input floated"
      placeholder="搜索成员名称或电话号码"
      type="text"
      v-model.trim="searchValue" />
    <div class="addon">
      <i class="slp-search"></i>
    </div>
  </div>

  <div class="shuttle-list" ref="scrollContainer">
    <div ref="scrollContent">
      <div class="shuttle-list-item justify-between" v-for="user in candidatedUsers">
        <div class="justify-box details-box">
          <headimg :src='user.headimgurl'></headimg>
          <div class="darken-text ml-2 details-name">
            <div class="text-ellipsis">{{ user.name }}</div>
            <div class="text-small light-gray-text text-ellipsis">{{ user.identifier }}</div>
          </div>
        </div>
        <div class="darken-text ml-8">{{ user.phone }}</div>
        <span class="btn outlined btn-primary" @click="selectUser(user)">添加</span>
      </div>
    </div>
    <div class="light-gray-text text-center" v-if="!hasMore && !loading">没有更多数据了</div>
  </div>
  <div class="load-box">
    <div class="justify-box loading-spinner" :class='{ "start-spin": loading }'>
      <i class="slp-loading spin text-large"></i>
    </div>
  </div>
</div>`,
  props: {
    queryUrl: {
      type: String,
      required: true
    },
    organizationId: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      selectedOrganizationId: 'members',
      searchValue: '',
      users: [],
      loading: false,
      currentPage: 0,
      hasMore: true,
      selectedUsers: []
    };
  },
  computed: {
    candidatedUsers: function() {
      return _.select(this.users, (user) => {
        return !_.any(this.selectedUsers, function(su) {
          return su.id === user.id;
        });
      });
    },
    searchUrl: function() {
      switch (this.selectedOrganizationId) {
        case 'members':
          return "/admin/users/query";
        case 'suspended_members':
          return "/admin/users/query?suspended=true";
        default:
          return this.queryUrl;
      }
    }
  },
  watch: {
    searchUrl: {
      handler: function(val) {
        return this.resetSearchValue();
      },
      immediate: true
    },
    searchValue: _.debounce(function() {
      return this.reset();
    }, 500)
  },
  mounted: function() {
    return this._bindEvent();
  },
  methods: {
    resetSearchValue: function() {
      if (this.searchValue) {
        return this.searchValue = '';
      } else {
        return this.reset();
      }
    },
    reset: function() {
      this.users = [];
      this.loading = false;
      this.currentPage = 0;
      this.hasMore = true;
      return this._doRequest();
    },
    updateSelectedOrganizationIdFunc: function(id) {
      this.selectedOrganizationId = id;
      // TODO: remove it
      return this.$emit('selectedOrganizationIdChanged', id);
    },
    selectUser: function(user) {
      this.selectedUsers.push(user);
      return this.$emit('userSelected', user);
    },
    deselectUser: function(user) {
      return this.selectedUsers = _.reject(this.selectedUsers, function(su) {
        return su.id === user.id;
      });
    },
    _doRequest: function() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      return Skylark.Libs.Ajax.get(this.searchUrl, {
        responseType: 'json',
        data: this._generateRequestData(),
        success: (data, req) => {
          var current_page, total_pages;
          current_page = parseInt(req.getResponseHeader('X-SLP-Current-Page'), 10);
          total_pages = parseInt(req.getResponseHeader('X-SLP-Total-Pages'), 10);
          this.hasMore = current_page < total_pages;
          this.currentPage = current_page;
          return this.users = this.users.concat(data);
        },
        complete: () => {
          return this.loading = false;
        }
      });
    },
    _generateRequestData: function() {
      return {
        exclude_organization_id: this.organizationId,
        keyword: this.searchValue,
        page: this.currentPage + 1,
        __new__: true
      };
    },
    _bindEvent: function() {
      var ref;
      this.$scroll_container_el = this.$refs.scrollContainer;
      return (ref = this.$scroll_container_el) != null ? ref.onscroll = _.debounce((e) => {
        if (this.hasMore) {
          return this._loadMore(e);
        }
      }, 300) : void 0;
    },
    _loadMore: function(e) {
      var container_offset_height, container_scroll_height, scrollTopValue;
      scrollTopValue = e.target.scrollTop;
      container_offset_height = this.$scroll_container_el.offsetHeight;
      container_scroll_height = this.$refs.scrollContent.scrollHeight;
      // 监听scrollContainer是否滚动到底部
      if (scrollTopValue === (container_scroll_height - container_offset_height)) {
        return this._doRequest();
      }
    }
  }
};
